import React from 'react';
import { View, StyleSheet, type StyleProp, ViewStyle, Platform } from 'react-native';

interface CardProps {
    children: React.ReactNode;
    style?: StyleProp<ViewStyle>;
}

export default function Card({ children, style }: CardProps) {
    return (
        <View style={[styles.card, style]}>
            {children}
        </View>
    );
}

const styles = StyleSheet.create({
    card: {
        backgroundColor: '#fff',
        borderWidth: 1,
        borderColor: '#eee',
        borderRadius: 10,
        padding: 12,
        ...(Platform.OS !== 'web' && {
            shadowColor: '#000',
            shadowOpacity: 0.02,
            shadowOffset: { width: 0, height: 1 },
            shadowRadius: 1,
        }),
        ...(Platform.OS === 'web' && {
            boxShadow: '0px 1px 1px rgba(0,0,0,0.02)',
        }),
    },
});
